import { render, staticRenderFns } from "./KeyEquipment.vue?vue&type=template&id=3c5213cf&scoped=true&"
import script from "./KeyEquipment.vue?vue&type=script&lang=js&"
export * from "./KeyEquipment.vue?vue&type=script&lang=js&"
import style0 from "./KeyEquipment.vue?vue&type=style&index=0&id=3c5213cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5213cf",
  null
  
)

export default component.exports